import { Component, signal } from '@angular/core';

import { of } from 'rxjs';

import { UploadComponent } from '@camelot/form-input';
import { InputUpload } from '@camelot/form-model';
import { CamDocumentsService, FileType } from '@camelot/services';
import { DndDirective } from '@camelot/utils';

import { TestIdDirective } from '@camelot/testing-harness';

export const uploadSpy = {
  addCalls: signal(0),
};

const uploadedDocument = {
  fileType: FileType.Unknown,
  id: 'uploaded-1',
  name: 'uploaded.png',
  uploadedDate: '2026-01-01T10:00:00Z',
  url: 'https://mock.local/uploaded.png',
};

const documentsServiceMock = {
  addDocument$: () => {
    uploadSpy.addCalls.update(count => count + 1);
    return of(uploadedDocument);
  },
  documents: { get$: () => of([uploadedDocument]) },
  fetchDocuments$: () => of([uploadedDocument]),
  getDocuments$: () => of([uploadedDocument]),
};

@Component({
    imports: [DndDirective, TestIdDirective, UploadComponent],
    providers: [{ provide: CamDocumentsService, useValue: documentsServiceMock }],
    template: `
    <cam-input-upload camTestId="uf-upload" [input]="this.upload" [standalone]="true" />
    <div camTestId="uf-add-calls">{{ this.addCalls() }}</div>

    <div camTestId="uf-dropzone" appDnd (fileDropped)="this.dropped.set(this.dropped() + 1)">drop zone</div>
    <div camTestId="uf-dropped">{{ this.dropped() }}</div>
  `
})
export class UploadFilesCase {
  public addCalls = uploadSpy.addCalls;
  public dropped = signal(0);
  public upload = new InputUpload({ key: 'upload', label: 'Upload' });
}
